import '@/scss/style.scss'
import { HmwLightbox } from './lib/HmwLightbox'

new HmwLightbox('.hmw-lightbox', 'data-gallery-id') 